import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Usuarios'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Clientes'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Grupos de Trabajo'
, [ TEXT.UI_MENU_JOBS          ]: 'Tareas'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Amaestramientos'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Crear'
, [ TEXT.UI_BUTTON_NEW         ]: 'Nuevo'
, [ TEXT.UI_BUTTON_OK          ]: 'Aceptar'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Cancelar'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Guardar'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Entrar'
, [ TEXT.UI_BUTTON_SEND        ]: 'Enviar'


, [ TEXT.UI_EMAIL              ]: 'Email'
, [ TEXT.UI_ROLE               ]: 'Rol'
, [ TEXT.UI_USERNAME           ]: 'Usuario'
, [ TEXT.UI_NAME               ]: 'Nombre'
, [ TEXT.UI_DATE               ]: 'Fecha'
, [ TEXT.UI_ADDR               ]: 'Lugar'
, [ TEXT.UI_DESC               ]: 'Descripción'
, [ TEXT.UI_PRICE              ]: 'Precio'
, [ TEXT.UI_NO_DATA            ]: 'No hay datos'
, [ TEXT.UI_MACHINES           ]: 'Máquinas'
, [ TEXT.UI_USERS              ]: 'Usuarios'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Salir'
, [ TEXT.UI_MKS_TYPE           ]: 'Tipo MKS'
, [ TEXT.UI_KEY_APP            ]: 'Uso de la llave'
, [ TEXT.UI_CLIENT             ]: 'Cliente'
, [ TEXT.UI_FILE               ]: 'Fichero'
, [ TEXT.UI_SELECT_FILE        ]: 'Seleccionar Fichero'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Usuario'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Nube'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Clave de Acceso'



, [ TEXT.ARE_YOU_SURE          ]: '¿Estás seguro?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Usuario/Nube o clave incorrecta'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Usuario/Nube o clave incorrecta'
, [ TEXT.ERROR_INTERNAL        ]: 'Error en el servidor'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Acceso denegado'
, [ TEXT.ERROR_UNKNOWN         ]: 'Hubo un error. Pero no sabemos cual.'

, [ TEXT.PAGE_NOT_FOUND        ]: 'No se encontro la página'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Nuevo Grupo'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Editar Grupo'
, [ TEXT.WORKGROUPS_NAME       ]: 'Nombre Grupo'


, [ TEXT.USERS_NEW_TITLE       ]: 'Nuevo Usuario'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Editar Usuario'

, [ TEXT.MACHINE_TYPE          ]: 'Tipo Máquina'
, [ TEXT.MACHINE_NUM_JOBS      ]: 'Nº Tareas'
, [ TEXT.MACHINE_NAME          ]: 'Máquina'

, [ TEXT.CLIENT_NEW_TITLE      ]: 'Nuevo Cliente'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Editar Cliente'
, [ TEXT.CLIENT_ADDRESS        ]: 'Dirección'
, [ TEXT.CLIENT_CONTACT        ]: 'Contacto'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'Email'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Teléfono'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'Apellidos'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Fecha Nacimiento'
, [ TEXT.CLIENT_NOTES          ]: 'Notas'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Filtrar Nombre'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Filtrar Dirección'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filtrar Contacto'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Dirección'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'Ciudad'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Provincia'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Cód. Postal'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'País'


, [ TEXT.MACHINES_NEW          ]: 'Nueva Máquina'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Nº Serie'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Editar Tarea'
, [ TEXT.JOB_NEW_TITLE         ]: 'Nueva Tarea'
, [ TEXT.JOB_KEY_TYPE          ]: 'Modelo'
, [ TEXT.JOB_NUM_KEYS          ]: 'Cantidad'
, [ TEXT.JOB_MACHINE           ]: 'Máquina'
, [ TEXT.JOB_STATUS            ]: 'Estado'
, [ TEXT.JOB_DATE              ]: 'Fecha'
, [ TEXT.JOB_QUANTITY          ]: 'Nueva cantidad'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filtrar Estado'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filtrar Clientes'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filtrar Máquina'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Filtrar Tipo Llave'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filtrar Fecha'


, [ TEXT.KEY_MASTERING_LAUNCH             ]: 'Lanzar'
, [ TEXT.KEY_MASTERING_LAUNCH_N           ]: 'Lanzar ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE          ]: 'Cargar Amaestramiento'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: 'Se van a crear {num} llaves. ¿Estás seguro?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: 'Se han creado {num} tarea(s)'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Nombre Amaestramiento'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION  ]: '¿Olvidó la clave?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE     ]: 'Enviar instrucciones a'
, [ TEXT.LOGIN_SLOGAN                    ]: 'La primera applicación de duplicado de llaves basada en la nube'
, [ TEXT.LOGIN_QUALITY_POINTS            ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
  <ul class="login-sell-points">
  <li>Registre los duplicados de llaves realizados a sus clientes</li>
  <br>
  <li>Almacene los datos sin riesgo de perderlos y acceda a ellos desde cualquier lugar</li>
  <br>
  <li>Actualizaciones automáticas</li>
</ul>
`


, [ TEXT.LEGAL_TOS_TEXT              ]: 'Aviso legal'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Política de privacidad'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Modelo acuerdo'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/es/legal_notice_es.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/es/privacy_policy_es.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/es/model_es.docx'

, [ TEXT.KEY_MODEL                   ]: 'Modelo'
, [ TEXT.KEY_SERIES                  ]: 'Serie'
, [ TEXT.KEY_CODE                    ]: 'Código'
, [ TEXT.KEY_DATA_SHEET              ]: 'Ficha'
, [ TEXT.KEY_BITING                  ]: 'Dentado'
, [ TEXT.KEY_APPLICATION             ]: 'Aplicación'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'PENDIENTE'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'CANCELADA'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'COMPLETADA'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'PROCESANDO'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMINISTRADOR'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'GESTOR'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USUARIO'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'COCHE'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'HOGAR'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SEGURIDAD'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'CANDADO'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'SIN ESPECIFICAR'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Por favor, rellena los campos obligatorios marcados en rojo'
}

export default ES ;
